export default __webpack_public_path__ + "static/media/premium-tracking-phone.eca7ece4.jpg";